export const FAQS = {
    HOME:[
        {   id:0,
            question:"Who all can avail Supply Chain Finance?",
            answers:"Any private or public entity is eligible to avail supply chain finance. Sole proprietorship and partnership companies can also use this facility. "
          },
          {
            id:1,
            question:"What is the repayment tenure of supply chain finance? ",
            answers:"The repayment tenure of supply chain finance is 12 months. As per the business requirements, it can also be extended."
          },
          {
            id:2,
            question:"What are the types of SME loans for supply chain finance? ",
            answers:"The four common types of SME loans for supply chain finance are invoice financing, purchase order financing, supply chain financing, and inventory financing."
          },
          {
            id:3,
            question:"How is the interest rate calculated and finalized by the company providing supply chain finance?",
            answers:"The supply chain finance company calculates the interest rate based on how much of the credit limit the client has used up. "
          },
          {
            id:4,
            question:"How many limits can a business avail from supply chain finance? ",
            answers:"A business can receive up to 80% to 85% of the total value of the invoice. It also depends on the specific requirements and eligibility criteria set by the supply chain finance company. "
          }
    ],
    INVOICEDISCOUNTING:[
        {id:0,
            question:"What is Invoice Discounting?",
            answers:"Invoice discounting is a kind of financing where a business can raise funds against its outstanding invoices from a financial institution. "
          },
          {
            id:1,
            question:"How does it work?",
            answers:"Based on the time period for which the invoice is outstanding, the lender charges a fee for its services. The business repays the lender once the customer pays the invoice."
          },
          {
            id:2,
            question:"What is the eligibility criteria for businesses?",
            answers:"The monthly turnover for the business, business visibility, active clients in your business, and outstanding invoices amount are some of the eligibility criteria for businesses to avail of invoice discounting."
          },
          {
            id:3,
            question:"Does Credlix have an upper sanction limit?",
            answers:"At Credlix, you can avail Working Capital Limits up to INR 40 Cr. "
          },
          {
            id:4,
            question:"Will availing invoice discounting affect the balance sheet?",
            answers:"By using invoice discounting, a company can raise funds without adding liabilities to their balance sheet. There is no increase in their debt."
          },
          {
            id:5,
            question:"Is invoice discounting a funded credit product?",
            answers:"Invoice discounting works like a revolving credit. The lender forwards funds against outstanding invoices based on their worth."
          },
          {
            id:6,
            question:"How long does it take to avail funds through invoice discounting?",
            answers:"Invoice discounting works like a revolving credit. The lender forwards funds against outstanding"
        },
        {
            id:7,
            question:"How can Invoice Discounting benefit my business?",
            answers:"Invoice discounting can benefit your business in many ways:",
            list:['Quick working capital for growth','No collateral','Eliminates risk','Reduced financial obligations']
              
          },
          {
            id:8,
            question:"Which is the best discounting platform in India?",
            answers:"Credlix is the best discounting platform in India. You can now secure faster funding for your export invoices using minimal documentation and zero hard collateral."
          },
          {
            id:9,
            question:"What are the Features & Benefits of Invoice Discounting?",
            answers:"Features & Benefits of Invoice Discounting:",
            list:['Increased cash flow and working capital','Full control','Bad debt protection','Interest only on the borrowed money','Not mandatory to inform the client','Quick cash flow','Business expansion and increased profits']
          },
          {
            id:10,
            question:"What is the Eligibility Criteria for Invoice Discounting?",
            answers:"The eligibility criteria for invoice discounting is as follows:",
            list:['No bad debts','Good payment record from your customersl','Robust credit control','Has a turnover of a certain amount as specified by the financier.']
          },
          {
            id:11,
            question:"What are the Documents Required for Invoice Discounting?",
            answers:"Following are the documents required for Invoice Discounting",
            list:['Passport-size photographs','Business Plan','KYC documents of the applicant(s)','Business address and vintage proof.',"Income proof along with last 2 years' ITR, GST and Sales tax returns","Copies of all the registrations, certificates and licenses","Last 6 months' bank statements","Detailed information on required discounting","Business financials - audited by CA"]
          },
          {
            id:12,
            question:"What is the Interest Rates for Invoice Discounting?",
            answers:"Discount charges are similar to bank interest, with typical rates ranging from 1.5% to 3% above the base rate. The calculation of the discount charge is on a daily basis and is typically applied on a monthly basis.",
            
          },
    ],
   
    PURCHASEORDER:[
        {id:0,
            question:"What is purchase order financing?",
            answers:"Purchase order financing is a kind of short-term funding where a lender provides funds to a business to fulfill a customer's purchase order. "
          },
          {
            id:1,
            question:"What is the repayment period for Purchase Order Financing?",
            answers:"The repayment period for purchase order financing is mostly short term, ranging from 30-120 days. "
          },
          {
            id:2,
            question:"Who can benefit from purchase order financing?",
            answers:"Government contracts, wholesale distributors, industrial, manufacturing, importers, exporters, and direct-ship orders are some of the businesses that can benefit from PO financing. "
          },
          {
            id:3,
            question:"Is collateral required for Purchase Order Financing? ",
            answers:"Simply put, the purchase order works as a legally binding contract between the lender and the receiver. No collateral is required."
          },
          {
            id:4,
            question:"What is the interest rate for Purchase Order Financing?",
            answers:"Interest rates for purchase order financing is typically higher than traditional loans, ranging from 1.5% to 6% per month."
          },
          {
            id:5,
            question:"How much financing can be obtained through Purchase Order Financing?",
            answers:"The lender, the receiver’s creditworthiness, and the agreement are some of the factors that determine how much financing can be obtained through PO financing. At Credlix, get up to 40% of the purchase order value financed. "
          },
          {
            id:6,
            question:"Can Purchase Order Financing be used for international transactions?",
            answers:"Yes, purchase order financing can be used for international transactions, but it may involve some unforeseen risks."
        },
    ],
   
    DOMESTIC:[
        {
            id:0,
            question:"Can invoice financing be beneficial for SMEs? ",
            answers:"Yes, invoice discounting is beneficial for SMEs as it improves their cash flow, provides access to working capital, and reduces the risks of non-payment. It leads to SMEs growth. "
        },
        {
            id:1,
            question:"What are the advantages of invoice discounting in business?",
            answers:"Invoice discounting can benefit your business in many ways: ",
            list:['Quick working capital for growth','No collateral','Eliminates risk','Reduced financial obligations']
        },
        {
            id:2,
            question:"What is invoice financing or invoice discounting?",
            answers:"Invoice discounting is a kind of financing where a business can raise funds against its outstanding invoices from a financial institution."
        },
        {
            id:3,
            question:"Why should I prefer invoice discounting?",
            answers:'You should prefer invoice discounting because it enables cash flow in the business as and when needed. In most cases, it also works as a protection against bad debt.'
        },
    ],
    VENDORFINANCE:[
        {
            id:0,
            question:"What is third-party vendor financing?",
            answers:"Third-party vendor financing is a financial agreement where a third-party vendor like Credlix provides the loan. It refers solely to debt financing."
        },
        {
            id:1,
            question:"Why should a business opt for vendor financing?",
            answers:"A business should opt for vendor financing because it enables the easy purchase of goods and services while saving a lot of interest on borrowed amounts from financial institutions.",
        },
        {
            id:2,
            question:"How much credit can I receive through vendor financing?",
            answers:"The credit you can receive through vendor financing depends on various factors like your creditworthiness, the vendor's policies, the type of product or service being offered, and the terms of the financing agreement."
        },
        {
            id:3,
            question:"What should I know before opting for vendor finance?",
            list:['Interest rate and fees','Repayment terms','Credit requirements','Vendor reputations','Legal considerations']
        },
        {
            id:4,
            question:"What is the interest rate offered by the vendor to the borrower or buyer for vendor financing?",
            answers:"Depending on the agreement between the two parties, the interest rate can range from 5% to 10% or even higher."
        },
        {
            id:5,
            question:"When should one opt for vendor financing?",
            answers:"When the traditional lending institution refuses to lend money for some reason, one can opt for vendor financing."
        },
        {
            id:6,
            question:"What is the repayment period of Vendor Finance?",
            answers:"Repayment period of vendor financing can range from a few months to several years, depending on the amount of financing."
        },
    ],
    CHANNELFINANCE:[
        {
            id:0,
            question:"What is the objective of channel financing?",
            answers:'The main objective of channel financing, also known as dealer financing, is to enable manufacturing and trading companies to sell to their dealers, distributors, and stockists on cash and not debt.'
        },
        {
            id:1,
            question:"What is channel finance?",
            answers:"Channel finance is a financial facility for buyers, distributors, and dealers that aids in facilitating working capital requirements of the businesses across the globe. Supply chain finance is one of the most common types of channel finance. Furthermore, bill discounts and cash credit are popular options to extend channel finance, and bring the credit cycle to zero with quick cash infusion. To boost your supply chain management, channel financing is one of the most effective ways.  "
        },
        {
            id:2,
            question:"What is channel finance in banking?",
            answers:"Channel financing is a very helpful finance system through which the banks meet multiple fund necessities along with the supply chain at the supplier’s end. It enables easy cash flow for the business."
        },
        {
            id:3,
            question:"What are the interest and fees for the channel financing?",
            answers:"Based on multiple factors like the creditworthiness of the channel partner and the length of the financing period, the interest and fee rates for channel financing can vary."
        },
        {
            id:4,
            question:"Who can avail supply chain finance?",
            answers:"Companies of all sizes and industries that have a supply chain with multiple partners can avail themselves of supply chain finance."
        },
        {
            id:5,
            question:"What is the limit to avail supply chain finance?",
            answers:"A business can receive up to 80% to 85% of the total value of the invoice. It also depends on the specific requirements and eligibility criteria set by the supply chain finance company. "
        },
        {
            id:6,
            question:"What is the Interest Rates for Channel Financing?",
            answers:"As per the loan tenure, the interest rates of channel financing starts from 12%. It can fluctuate based on multiple factors you should be aware of beforehand like creditworthiness of the entities involved, prevailing market conditions, and the specific terms. "
        },
        {
            id:7,
            question:"What are the Documents Required for Channel Financing?",
            answers:"Yes, there are some risks associated with using an early payment discount solution like:",
            list:['Certificate of business existence','ITR for the last year.','House and business address proof','PAN card','Aadhaar card.','Profit and loss statements for the past 3 years, etc.'],
        },
        {
            id:8,
            question:"What is the Eligibility Criteria for Channel Financing?",
            answers:"The eligibility criteria for channel financing is as follows: ",
            list:['₹7.5 Lakhs turnover or more.','Should be a business owner or have a residential property. ','Should have 3 years of vintage.  ','Should have an ITR of a minimum of ₹1.5 Lakhs'],
        },
        {
            id:9,
            question:"What are the Features & Benefits of Channel Finance?",
            answers:"Features of Channel Finance:",
            list:['Quick approval process','Loan without collateral ','Convenient','Flexibility in payment'],
            answers2:"Benefits of Channel Finance:",
            list2:['Collateral free','Easy process','Lesser risk','Smooth cash flow','Fast funds','Less chances of bad debt','Better work efficiency']
        },
        {
            id:10,
            question:"How can one apply for Channel Financing?",
            answers:"Here’s how you can easily apply for Channel Financing at Credlix: ",
            list:['Visit our website https://www.credlix.com/','Login with your details','Should have 3 years of vintage.  ','“Apply Now” for availing of the facility.'],
        },
    ],
    EARLYPAYMENT:[
        {
            id:0,
            question:"What is an early payment discount solution?",
            answers:'An early payment discount is a type of financial arrangement that allows purchasers to pay a reduced amount to suppliers in return for settling invoices before the scheduled due date. '
        },
        {
            id:1,
            question:"What are the benefits of an early payment discount solution for buyers?",
            list:['Cost savings','Improved cash flow','Stronger supplier relationships','Reduced risk']
        },
        {
            id:2,
            question:"What types of businesses can benefit from an early payment discount solution?",
            list:['Small businesses','Business with high invoice volumes','Businesses with tight cash flow','Businesses in highly competitive industries.']
        },
        {
            id:3,
            question:"What are the costs associated with using an early payment discount solution?",
            answers:"An early payment discount is calculated as a percentage of the goods and services purchased. There are no direct costs associated with using an early payment discount solution. "
        },
        {
            id:4,
            question:"Can an early payment discount solution improve a company's credit score?",
            answers:"Yes, an early payment discount solution can improve a company’s credit score in the following ways: ",
            list:['Shows financial responsibility','Reduces outstanding debt','Increases cash flow'],
        },
        {
            id:5,
            question:"Are there any risks associated with using an early payment discount solution?",
            answers:"Yes, there are some risks associated with using an early payment discount solution like:",
            list:['Cash flow concerns','Reduced profit margin','Implementation costs','Inability to collect'],
        },
        {
            id:6,
            question:"What are the factors that determine the size of the early payment discount?",
            answers:"Some factors that determine the size of the early payment discount are:",
            list:['Payment terms','Industry norms','Cash flow needs','Profit margins','Market conditions'],
        },
    ]
        
    
            

}